module.exports = __webpack_public_path__ + "static/media/smallRedHat.b2f31535.png";